import React from "react";
import dynamic from "next/dynamic";
import DealsPageBooks from "@components/DealsPage/DealsPageBooks";
const Carousel = dynamic(() => import('react-responsive-carousel').then((mod) => mod.Carousel), { ssr: false });

import "react-responsive-carousel/lib/styles/carousel.min.css";

import "./Deals.css";

const Deals = ({
  deals,
  retailerCookie,
  siteDealsURL,
  titleText,
  showIndicators = true,
  interestPage = false,
}) => {
  const renderDeals = () => {
    if (deals) {
      const books = deals.map((book, idx) => (
        <DealsPageBooks
          key={idx}
          dealsPageBookProps={{
            ...book.props,
            renderDescription: false,
            renderPreview: false,
            renderOnSale: true,
            renderPrimaryAuthors: true,
            interestPage,
            titleText,
          }}
          preferredRetailer={retailerCookie}
        />
      ));
      return (
        <div className="carousel-container">
          <Carousel
            infiniteLoop
            showStatus={false}
            showArrows={false}
            showThumbs={false}
            showIndicators={showIndicators}
          >
            {books}
          </Carousel>
          {siteDealsURL && (
            <a target="_blank" rel="noopener" href={`${siteDealsURL}`}>
              <span className="carousel-discover-text">
                Discover More Great Deals
              </span>
              <img src={`${process.env.S3_IMAGE_URL}/chevron-blue.png`} />
            </a>
          )}
        </div>
      );
    }
  };
  return <>{renderDeals()}</>;
};

export default Deals;
